import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RoleRoute({ allowedRoles }) {
    const { user, loading, hasFeatureAccess } = useAuth();

    if (loading) return <div className="p-8 text-center text-gray-500">Loading...</div>;

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(user.role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    // Check plan configurations
    const path = window.location.pathname;
    if (path.startsWith('/kitchen') && !hasFeatureAccess('kitchen_dashboard')) {
        return <Navigate to="/unauthorized?reason=plan_restricted&feature=kitchen" replace />;
    }
    if (path.startsWith('/delivery') && !hasFeatureAccess('delivery_dashboard')) {
        return <Navigate to="/unauthorized?reason=plan_restricted&feature=delivery" replace />;
    }

    return <Outlet />;
}
